module.exports = __webpack_public_path__ + "img/logo.550948d1.png";